module.exports = __webpack_public_path__ + "img/ปลาแซลมอน.c6341a39.jpg";